import React from "react";

const Modal = ({ isOpen, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div
        onClick={(e) => e.stopPropagation()} // Prevent modal close when clicking inside
      >
        {children}
      </div>
    </div>
  );
};

export default Modal;
